import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoryGroupSection.css";

export default function CategoryGroupSection({ groups = [] }) {
  const navigate = useNavigate();

  const visibleGroups = (groups || []).filter((group) => {
    const title = String(
      group?.title || group?.group_name || group?.name || ""
    ).trim();

    return title.length > 0;
  });

  return (
    <section className="cg-section">
      <div className="cg-container">
        {visibleGroups.map((group) => {
          const title = String(
            group?.title || group?.group_name || group?.name || ""
          ).trim();

          return (
            <div className="cg-card" key={group.id || title}>
              <h2 className="blackcolor" style={{ marginBottom: 0,color:'black !important' }}>{title}</h2>

              <div className="cg-items">
                {group.items?.map((item) => (
                  <div
                    className="cg-item"
                    key={item.id}
                    onClick={() => {
                      const category = encodeURIComponent(item.name || item.title || item.label || "");
                      if (category) {
                        navigate(`/search?category=${category}`);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.name}
                        className="cg-image"
                      />
                    ) : (
                      <div className="cg-icon">{item.icon}</div>
                    )}

                    <span>{item.name}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}